module.exports = __webpack_public_path__ + "static/media/pic_fenxing2.b15b549f.png";